import { styled } from '../theming';
import PropTypes from 'prop-types';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';
import { Link, LinkProps } from '../Link';

export type NavBarLinkProps = {
  // seems like if we expand Link component with this prop, we wouldn't need this component
  isActive?: boolean;
};

/**
 * This styled component doesn't use `responsiveProp()` on purpose but instead defines media queries manually.
 * Consuming apps sometimes have the need to render `<NavBarLink>` as something other than `<a>` – this can be
 * a dedicated component of a framework like Gatsby's `<Link>`.
 * If this styled component were to set e.g. the `padding` via `responsiveProp()`, a Gatsby `<Link>` would be rendered
 * as `<a padding="[object Object] ...>`.
 */
export const NavBarLink = styled(Link)<LinkProps<'a'> & NavBarLinkProps>`
  text-decoration: none;
  cursor: pointer;
  width: 100%;
  white-space: nowrap;
  padding: 12px 0;

  @media (min-width: ${tokens.viewports.breakpoints.small}) {
    padding: 0;
    justfy-content: flex-start;
  }
`;

NavBarLink.propTypes = {
  children: PropTypes.node.isRequired,
  isActive: PropTypes.bool,
};
